import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import { sitesOptions } from "../queries/sitesQueries";
import { transformSiteInfoResponse } from "../sitesUtils";
import type { ISiteInfoConfig, ISiteInfoParams, SiteInfoQueryOptions, SiteInfoResponse } from "../types";

export const useSiteInfo = (
    params: ISiteInfoParams,
    config?: ISiteInfoConfig,
    options?: SiteInfoQueryOptions,
): UseQueryResult<SiteInfoResponse> => {
    return useQuery({
        ...sitesOptions.siteInfo(params, config, options),
        select: transformSiteInfoResponse,
    });
};
